import pipApi from "../../api/placements/pip";

export default {
  namespaced: true,

  state: {
    studentOpportunity: {}
  },

  mutations: {
    SET_STUDENTOPPORTUNITY(state, payload) {
      state.studentOpportunity = payload;
    }
  },

  actions: {
    createShell(context, studentOpportunity) {
      return new Promise((resolve, reject) => {
        pipApi
          .postCreate(studentOpportunity)
          .then(function(response) {
            context.commit("SET_STUDENTOPPORTUNITY", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    confirmShell(context, studentOpportunity) {
      return new Promise((resolve, reject) => {
        pipApi
          .postConfirm(studentOpportunity)
          .then(function(response) {
            context.commit("SET_STUDENTOPPORTUNITY", response.data);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    },
    updateShell(context, studentOpportunity) {
      return new Promise((resolve, reject) => {
        pipApi
          .putUpdate(studentOpportunity)
          .then(function(response) {
            context.commit("SET_STUDENTOPPORTUNITY", studentOpportunity);
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    }
  }
};
